<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-07-11 17:29:18
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-06-11 11:14:00
 * @FilePath: /qd-yunjing-web/src/components/base-area-select/index.vue
 * @Description: 这是默认设置,请设置`customMade`,
-->
<template>
  <section class="area-select-container">
    <div
      ref="spaceContainerRef"
      class="space-container"
    >
      <!-- <el-button
        key="plain"
        type=""
        text
      >
        <span class="value">{{ spaceValue }} </span>  <el-icon class="el-icon--right"><arrow-down /></el-icon>
      </el-button> -->
      <el-cascader
        ref="refCascader"
        v-model="space"
        :props="spaceProps"
        class="space-cascader"
        :popper-class="`area-cascader${props.level}`"
        :options="spaceOptions"
        collapse-tags
        :show-all-levels="false"
        clearable
        @change="handleValChange"
      />
    </div>
  </section>
</template>
<script setup lang="ts">
  import {
    ref, computed,
  } from 'vue';
  import { useOrgStore } from '@/store/org';
  import { CascaderProps } from 'element-plus';

  const props = defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
    isMultiple: { // 是否多选
      type: Boolean,
      default: true,
    },
    level: { // 子级展示层数
      type: Number,
      default: 0,
    },
    isCheckStrictly: {
      type: Boolean,
      default: true,
    },
  });

  const emit = defineEmits(['area-change']);
  const orgStore = useOrgStore();
  const refCascader = ref();

  const spaceOptions = computed(() => [{
    id: 0,
    name: '全部',
    orgId: '0',
    code: '0',
    children: orgStore.spaceOptions,
  }]);
  console.log('spaceOptions', spaceOptions);
  const space = computed(() => orgStore.multiSpace);
  // const spaceOptions = ref();

  /*
   * const getLastNode = (node: any[][]): any[] => node
   *   .filter((subNode) => subNode.length > 0)
   *   .map((subNode) => subNode[subNode.length - 1]);
   */

  const getValue = () => {
    const node = refCascader.value?.getCheckedNodes(false);
    if (!node) {
      return [];
    }
    return node.map((item:any) => item.value);
  };

  /*
   * watch(space, (val:any) => {
   *   console.log('space发生了变化', val);
   */
  /*
   *   const valArr = getValue();
   *   emit('area-change', valArr || []);
   *   orgStore.setMultiSpace(valArr || []);
   * }, {
   *   immediate: true,
   * });
   */
  const spaceProps:CascaderProps = {
    checkStrictly: props.isCheckStrictly,
    label: 'name',
    value: 'code',
    expandTrigger: 'hover',
    multiple: props.isMultiple,
  };

  const handleValChange = (val: any) => {
    console.log('空间发生了变化');
    const lastNode = getValue();
    emit('area-change', lastNode || []);
    orgStore.setMultiSpace(lastNode || []);
  };
</script>
<style scoped lang="scss">
.area-select-container{
  flex: 1;
  width: 100%;
  margin-left: 10px;

  .space-container {
    width: 300px;
    overflow: hidden;
    line-height: 28px;
    background-color: transparent;
    border-radius: 5px;
  }
}

:deep(.ma-tag--light){
  background-color: #fff;
}
</style>
<style>
.area-cascader1{
  width: 160px !important;
  overflow: hidden;
}

.area-cascader2{
  width: 340px !important;
  overflow: hidden;
}

.area-cascader3{
  width: 500px !important;
  overflow: hidden;
}
</style>
